export default __webpack_public_path__ + "static/media/Mark-5-HUD-Targeting (TD).0478607b.jpg";